import React from "react";

// import { Footer, Blog, Possibility, Features, WhatPersbeTech, Header } from './containers';
// import {
//   Footer,
//   Projects,
//   Contact,
//   Features,
//   WhatPersbeTech,
//   Header,
// } from "./containers";
// import { CTA, Brand, Navbar } from './components';
// import { Brand, Navbar } from "./components";
import { Route, Routes } from "react-router-dom";

import "./App.css";
import Projecthydgeo from "./containers/Projecthydgeo";
import Projectkharah from "./containers/Projectkharah";
import Projectwmci from "./containers/Projectwmci";
import MainPg from "./MainPg";

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/*" element={<MainPg />} />
        <Route path="/projectwmci" element={<Projectwmci />} />
        <Route path="/projectkharah" element={<Projectkharah />} />
        <Route path="/projecthydgeo" element={<Projecthydgeo />} />
      </Routes>
    </div>
  );
};

export default App;
